import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Caption1 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useTimeRecordsTotalInfo } from "~/repository";
import { getProjectById } from "~/store/selectors/selector.projects";
import { getLoggedUser } from "~/store/selectors/selector.users";
import { isFinancialManager, isMember } from "~/utils/userHelper";
import { decimalToMinutes, hoursFormatted } from "~/utils/utils";

export const LimitedAccess = ({ projectId, parentType, parentId, from, to, shouldShowLimitedAccess, className }) => {
  const { t } = useTranslation();

  let query = {};

  if (from && to) {
    query = { ...query, from, to };
  }

  const { data } = useTimeRecordsTotalInfo(parentType, parentId, query);

  const loggedUser = useSelector((state) => getLoggedUser(state));
  const project = useSelector((state) => getProjectById(state, projectId));

  const showLimitedAccess =
    isMember(loggedUser) &&
    !isFinancialManager(loggedUser) &&
    project.leader_id !== loggedUser.id &&
    data?.other_time > 0 &&
    shouldShowLimitedAccess;

  return (
    <>
      {showLimitedAccess ? (
        <div className={classNames("tw-border-solid tw-border-0 tw-border-t tw-border-border-primary", className)}>
          <div className="tw-px-1 tw-flex tw-justify-between tw-items-center tw-mt-4">
            <Caption1 weight="bold">{t("Limited Access")}</Caption1>
            <Caption1
              weight="medium"
              color="secondary"
              tabularNums
            >
              {t("Total")}: {hoursFormatted({ hours: 0, minutes: decimalToMinutes(data?.other_time) }, false, true)}h
            </Caption1>
          </div>
        </div>
      ) : null}
    </>
  );
};

LimitedAccess.propTypes = {
  projectId: PropTypes.number.isRequired,
  parentType: PropTypes.string.isRequired,
  parentId: PropTypes.number.isRequired,
  from: PropTypes.string,
  to: PropTypes.string,
  shouldShowLimitedAccess: PropTypes.bool,
  className: PropTypes.string,
};

LimitedAccess.defaultProps = {
  shouldShowLimitedAccess: false,
};
